const GET_PRODUCTS = 'GET_PRODUCTS';
const GET_SERVICES = 'GET_SERVICES';
const INSERT_PRODUCTS = 'INSERT_PRODUCTS';
const INSERT_SERVICES = 'INSERT_SERVICES';

export {GET_PRODUCTS, GET_SERVICES, INSERT_PRODUCTS, INSERT_SERVICES}